import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const anchorNavigation = () => {
  const anchorNavSwiper = document.querySelectorAll(
    ".js-anchor-navigation-swiper"
  );

  anchorNavSwiper.forEach(function (swiperClass) {
    let next = swiperClass.parentNode.querySelector(".previous");
    let prev = swiperClass.parentNode.querySelector(".next");

    const options = {
      modules: [Navigation],
      slidesPerView: "auto",
      slideToClickedSlide: true,
      spaceBetween: 16,
      watchSlidesProgress: true,
      breakpoints: {
        1280: {
          spaceBetween: 20,
        },
        1440: {
          spaceBetween: 24,
        },
      },

      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    };

    const swiper = new Swiper(swiperClass, options);
  });
};

const anchorNavigationHeight = () => {
  const anchorNavScroll = document.querySelectorAll(
    ".js-anchor-navigation-scroll"
  );

  for (let i = 0; i < anchorNavScroll.length; i++) {
    const sectionHeight = anchorNavScroll[i].offsetHeight;
    anchorNavScroll[i].style.height = sectionHeight + "px";
  }
};

const anchorNavigationScroll = () => {
  const anchorNavScroll = document.querySelectorAll(
    ".js-anchor-navigation-scroll"
  );

  if (typeof anchorNavScroll === "undefined" && anchorNavScroll === null) {
    return;
  }

  for (let i = 0; i < anchorNavScroll.length; i++) {
    window.addEventListener(
      "scroll",
      function (e) {
        const tableContents = document.querySelector(".table-contents-header");

        const headerElem = document.querySelector(".js-menu-scroll");

        let topHeight = headerElem.offsetHeight;
        let locationHeight = anchorNavScroll[i].offsetTop;

        if (typeof tableContents != "undefined" && tableContents != null) {
          topHeight = tableContents.offsetHeight + headerElem.offsetHeight;
          locationHeight =
            anchorNavScroll[i].offsetTop - tableContents.offsetHeight;
        }

        if (headerElem.classList.contains("is-scrolling")) {
          topHeight = 0;
        }

        if (
          headerElem.classList.contains("is-scrolling") &&
          typeof tableContents != "undefined" &&
          tableContents != null
        ) {
          topHeight = tableContents.offsetHeight;
        }

        if (window.scrollY >= locationHeight) {
          anchorNavScroll[i].querySelector(".anchor-navigation").style.top =
            topHeight + "px";
          anchorNavScroll[i].classList.add("is-fixed");
        } else {
          anchorNavScroll[i].classList.remove("is-fixed");
          anchorNavScroll[i]
            .querySelector(".anchor-navigation")
            .removeAttribute("style");
        }
      },
      { passive: true }
    );
  }
};

document.addEventListener("DOMContentLoaded", function () {
  anchorNavigation();
  anchorNavigationHeight();

  anchorNavigationScroll();
});

window.addEventListener(
  "resize",
  function (event) {
    anchorNavigationHeight();
  },
  true
);
